import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=278c6460&scoped=true&"
import script from "./Nav.vue?vue&type=script&lang=ts&"
export * from "./Nav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278c6460",
  null
  
)

export default component.exports